import { useEffect, useRef } from "react";

export default function HyperbolaBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener("resize", resize);

    let t = 0;

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const cx = canvas.width / 2;
      const cy = canvas.height / 2;

      ctx.lineWidth = 2;
      ctx.shadowBlur = 20;
      ctx.shadowColor = "#ffd27d";

      for (let i = 1; i <= 3; i++) {
        const a = 280 * i;

        ctx.beginPath();
        for (let x = -cx; x < cx; x += 3) {
          const wave = Math.sin(t / 120 + i) * 60;
          const y = a / (x + wave);

          const px = cx + x;
          const py = cy + y;

          if (x === -cx) ctx.moveTo(px, py);
          else ctx.lineTo(px, py);
        }

        ctx.strokeStyle = `rgba(255, 210, 125, 0.25)`;
        ctx.stroke();
      }

      t += 1;
      requestAnimationFrame(draw);
    };

    draw();
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        background: "radial-gradient(circle at top, #1b1b2f, #0f0f1a)"
      }}
    />
  );
}
